import type { ReactNode } from 'react'
import { VpIcon, VpIconButton } from '@vtmn-play/react/headless'
import './count-with-details-button.scss'

export function CountWithDetailsButton({
  children,
  ariaLabel,
  dataTestid,
  onOpenDetails,
}: Readonly<{
  children: ReactNode
  ariaLabel: string
  dataTestid: string
  onOpenDetails: () => void
}>) {
  return (
    <div className="count-with-details-button">
      {children}
      <VpIconButton
        onClick={onOpenDetails}
        aria-label={ariaLabel}
        name="eye"
        variant="tertiary"
        data-testid={dataTestid}
        size="small"
      >
        <VpIcon name="eye" size={20} />
      </VpIconButton>
    </div>
  )
}
